import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { firstMap } from "keautils";
import { SelectQueryProps, SelectQueryViewProps, SelectQueryViewPropsRx } from "kea-react/dist/selector/query";
import { observeResource } from "kea-resource";
import { DepositoBancoFiltro } from "app/models/requireme";

type Entity = models.DepositoBancoDTO;

export interface DepositoBancoDTOEditProps extends kea.ModalProps<Entity, boolean, undefined> {
}

export class DepositoBancoDTOItem extends React.PureComponent<{ value: models.DepositoBancoDTO }> {
    render() {
        const x = this.props.value;
        return (
            <div>
                <span>
                    <i className={fa("calendar-check-o", "fw")} />
                    <label>{x.FechaDeposito}</label>
                </span>
                <br/>
                {
                    <span>
                        <i className={fa("building-o", "fw")} />
                        {x.NombreSucursal}
                    </span>
                }
                <br/>
                {
                    <span>
                        <i className={fa("user-circle-o", "fw")} />
                        {x.NombreUsuario}
                    </span>
                }
                <br/>
                {
                    <span>
                        <i className={fa("dollar", "fw")} />
                        <b>{kea.formatCurrency(x.ImporteDeposito)}</b>
                    </span>
                }
            </div>
        )
    }
}

function mapSelectItem(x: models.DepositoBancoDTO): kea.SelectorElement {
    return {
        value: x.IdRegistro,
        label: x.SerieFolio,
        view: <DepositoBancoDTOItem value={x} />
    }
}

export interface SelectorDepositoBancoDTOProps extends SelectQueryViewPropsRx {
    /**Filtro extra para el selector de DepositoBancoDTOs */
    filtro?: DepositoBancoFiltro;
}

export class DepositoBanco extends React.PureComponent<SelectorDepositoBancoDTOProps> {
    modalManager = kea.createModalManager();

    filtro = (props: SelectorDepositoBancoDTOProps) => props.filtro || {};
    readOnly = (props: SelectorDepositoBancoDTOProps) => props.readonly;

    loadItems = createSelectorRx(this.filtro,
        filtro => kea.loadSelectorItemsFuncFromResource(busqueda => observeResource(resources.DepositoBanco.Query, {
            Sucursal: busqueda,
            ...filtro,
        }), id => observeResource(resources.DepositoBanco.Get, id), mapSelectItem)
    )

    render() {
        const loadItemsFunc = this.loadItems(this.props);
        return (
            <div>
                <kea.SelectQuery label="Deposito banco" loadItems={loadItemsFunc} {... this.props} />
                {this.modalManager.component}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/selectores/items/deposito.tsx